import { clamp } from "@/utils/clamp";

export const REF_WIDTH = 430;
export const REF_HEIGHT = 932;

const PULL_UP_MIN = 72;
const PULL_UP_MAX = 128;

const PANEL_VISIBLE_MIN = 270;
const PANEL_VISIBLE_MAX = 400;
const PANEL_SHORT_MIN = 200;
const PANEL_SHORT_MAX = 300;

const PULL_UP_RATIO = 108 / REF_HEIGHT;
const PANEL_VISIBLE_RATIO = 334 / REF_HEIGHT;
const PANEL_SHORT_RATIO = 0.55;

export const LANDSCAPE_HEIGHT_LIMIT = 480;

export type PanelMetrics = {
  isHorizontal: boolean;
  pullUp: number;
  visible: number;
  visibleShort: number;
};

export const getPanelMetrics = (
  viewportHeight: number,
  viewportWidth: number,
  safeAreaTop = 0,
): PanelMetrics => {
  const isHorizontal =
    viewportHeight < LANDSCAPE_HEIGHT_LIMIT && viewportWidth > viewportHeight;

  return {
    isHorizontal,
    pullUp:
      Math.round(
        clamp(viewportHeight * PULL_UP_RATIO, PULL_UP_MIN, PULL_UP_MAX),
      ) + safeAreaTop,
    visible: Math.round(
      clamp(
        viewportHeight * PANEL_VISIBLE_RATIO,
        PANEL_VISIBLE_MIN,
        PANEL_VISIBLE_MAX,
      ),
    ),
    visibleShort: Math.round(
      clamp(
        viewportHeight * PANEL_SHORT_RATIO,
        PANEL_SHORT_MIN,
        PANEL_SHORT_MAX,
      ),
    ),
  };
};

export const DEFAULT_PANEL_METRICS: PanelMetrics = {
  isHorizontal: false,
  pullUp: 108,
  visible: 334,
  visibleShort: 300,
};
